<template>
  <div>
    <head>
      <link rel="shortcut icon" href="assets/images/favicon.svg">
      <link href="assets/css/bootstrap.min.css" id="bootstrap-style" rel="stylesheet" type="text/css" />
      <link href="assets/css/icons.min.css" rel="stylesheet" type="text/css" />
      <link href="assets/css/app.min.css" id="app-style" rel="stylesheet" type="text/css" />
      <link href="assets/css/custom.css" id="app-style" rel="stylesheet" type="text/css" />
    </head>

    <body @contextmenu.prevent data-sidebar="dark">
    <div id="layout-wrapper">
      <NavigationBar />

      <div id="content" class="content-minimize">
        <div class="page-content">
          <div class="container-fluid">

            <!-- Page Title -->
            <div class="row">
              <div class="col-12">
                <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                  <h4 class="mb-sm-0 font-size-18">Queue Management</h4>
                  <div class="page-title-right">
                    <ol class="breadcrumb m-0">
                      <li class="breadcrumb-item"><a @click="goTo('hospital-dashboard')">Hospital</a></li>
                      <li class="breadcrumb-item active">Queue Management</li>
                    </ol>
                  </div>
                </div>
              </div>
            </div>

            <!-- Stats Cards -->
            <div class="row">
              <div class="col-md-4 col-lg-2">
                <div class="card mini-stats-wid">
                  <div class="card-body">
                    <div class="d-flex">
                      <div class="flex-grow-1">
                        <p class="text-muted fw-medium mb-2">Triage</p>
                        <h4 class="mb-0">{{ stats.triage || 0 }}</h4>
                      </div>
                      <div class="mini-stat-icon avatar-sm align-self-center rounded-circle" style="background-color: rgba(241, 180, 76, 0.2);">
                          <span class="avatar-title" style="background: transparent; color: #f1b44c;">
                            <i class="mdi mdi-pulse font-size-24"></i>
                          </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-4 col-lg-2">
                <div class="card mini-stats-wid">
                  <div class="card-body">
                    <div class="d-flex">
                      <div class="flex-grow-1">
                        <p class="text-muted fw-medium mb-2">Consultation</p>
                        <h4 class="mb-0">{{ stats.consultation || 0 }}</h4>
                      </div>
                      <div class="mini-stat-icon avatar-sm align-self-center rounded-circle" style="background-color: rgba(85, 110, 230, 0.2);">
                          <span class="avatar-title" style="background: transparent; color: #556ee6;">
                            <i class="mdi mdi-stethoscope font-size-24"></i>
                          </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-4 col-lg-2">
                <div class="card mini-stats-wid">
                  <div class="card-body">
                    <div class="d-flex">
                      <div class="flex-grow-1">
                        <p class="text-muted fw-medium mb-2">Laboratory</p>
                        <h4 class="mb-0">{{ stats.lab || 0 }}</h4>
                      </div>
                      <div class="mini-stat-icon avatar-sm align-self-center rounded-circle" style="background-color: rgba(80, 165, 241, 0.2);">
                          <span class="avatar-title" style="background: transparent; color: #50a5f1;">
                            <i class="mdi mdi-test-tube font-size-24"></i>
                          </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-4 col-lg-2">
                <div class="card mini-stats-wid">
                  <div class="card-body">
                    <div class="d-flex">
                      <div class="flex-grow-1">
                        <p class="text-muted fw-medium mb-2">Pharmacy</p>
                        <h4 class="mb-0">{{ stats.pharmacy || 0 }}</h4>
                      </div>
                      <div class="mini-stat-icon avatar-sm align-self-center rounded-circle" style="background-color: rgba(52, 195, 143, 0.2);">
                          <span class="avatar-title" style="background: transparent; color: #34c38f;">
                            <i class="mdi mdi-pill font-size-24"></i>
                          </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-4 col-lg-2">
                <div class="card mini-stats-wid">
                  <div class="card-body">
                    <div class="d-flex">
                      <div class="flex-grow-1">
                        <p class="text-muted fw-medium mb-2">Total Active</p>
                        <h4 class="mb-0">{{ stats.total || 0 }}</h4>
                      </div>
                      <div class="mini-stat-icon avatar-sm align-self-center rounded-circle" style="background-color: rgba(116, 120, 141, 0.2);">
                          <span class="avatar-title" style="background: transparent; color: #74788d;">
                            <i class="mdi mdi-account-group font-size-24"></i>
                          </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-4 col-lg-2">
                <div class="card mini-stats-wid">
                  <div class="card-body">
                    <div class="d-flex">
                      <div class="flex-grow-1">
                        <p class="text-muted fw-medium mb-2">Completed</p>
                        <h4 class="mb-0 text-success">{{ stats.completed || 0 }}</h4>
                      </div>
                      <div class="mini-stat-icon avatar-sm align-self-center rounded-circle" style="background-color: rgba(52, 195, 143, 0.2);">
                          <span class="avatar-title" style="background: transparent; color: #34c38f;">
                            <i class="mdi mdi-check-circle font-size-24"></i>
                          </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Queue Table Card -->
            <div class="card">
              <div class="card-body">
                <!-- Header with Tabs and Actions -->
                <div class="d-flex flex-wrap justify-content-between align-items-center mb-4">
                  <div>
                    <h5 class="mb-1"><i class="mdi mdi-format-list-bulleted me-2 text-primary"></i>Patient Queue</h5>
                    <small class="text-muted">Manage and track patient visits</small>
                  </div>
                  <div class="d-flex gap-2">
                    <button class="btn btn-outline-secondary btn-sm" @click="loadQueue" :disabled="loading">
                      <i class="mdi mdi-refresh" :class="{ 'mdi-spin': loading }"></i> Refresh
                    </button>
                    <button class="btn btn-primary btn-sm" @click="goTo('new-visit')">
                      <i class="mdi mdi-plus me-1"></i> New Visit
                    </button>
                  </div>
                </div>

                <!-- Filter Tabs -->
                <ul class="nav nav-tabs nav-tabs-custom mb-4">
                  <li class="nav-item">
                    <a class="nav-link" :class="{ active: activeTab === 'ALL' }" @click="setTab('ALL')" href="javascript:void(0);">
                      All <span class="badge bg-secondary ms-1">{{ queueData.length }}</span>
                    </a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link" :class="{ active: activeTab === 'TRIAGE' }" @click="setTab('TRIAGE')" href="javascript:void(0);">
                      Triage <span class="badge bg-warning ms-1">{{ filterByStatus(['Waiting', 'In Triage']).length }}</span>
                    </a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link" :class="{ active: activeTab === 'CONSULTATION' }" @click="setTab('CONSULTATION')" href="javascript:void(0);">
                      Consultation <span class="badge bg-primary ms-1">{{ filterByStatus(['In Consultation']).length }}</span>
                    </a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link" :class="{ active: activeTab === 'LAB' }" @click="setTab('LAB')" href="javascript:void(0);">
                      Laboratory <span class="badge bg-info ms-1">{{ filterByStatus(['In Lab']).length }}</span>
                    </a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link" :class="{ active: activeTab === 'PHARMACY' }" @click="setTab('PHARMACY')" href="javascript:void(0);">
                      Pharmacy <span class="badge bg-success ms-1">{{ filterByStatus(['In Pharmacy']).length }}</span>
                    </a>
                  </li>
                </ul>

                <!-- Loading -->
                <div v-if="loading" class="text-center py-5">
                  <div class="spinner-border text-primary mb-3"></div>
                  <p class="text-muted mb-0">Loading queue...</p>
                </div>

                <!-- Empty State -->
                <div v-else-if="filteredQueue.length === 0" class="text-center py-5">
                  <div class="empty-state-icon mb-3">
                    <i class="mdi mdi-account-clock-outline"></i>
                  </div>
                  <h5 class="mb-2">No patients in queue</h5>
                  <p class="text-muted mb-4">There are no patients waiting in this queue.</p>
                  <button class="btn btn-primary" @click="goTo('new-visit')">
                    <i class="mdi mdi-plus me-1"></i> Create New Visit
                  </button>
                </div>

                <!-- Queue Table -->
                <div v-else class="table-responsive">
                  <table class="table table-hover align-middle mb-0">
                    <thead class="table-light">
                    <tr>
                      <th style="width: 80px;">Queue</th>
                      <th>Patient</th>
                      <th>Visit Type</th>
                      <th>Payment</th>
                      <th>Status</th>
                      <th>Wait Time</th>
                      <th>Chief Complaint</th>
                      <th style="width: 120px;">Actions</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr
                        v-for="item in filteredQueue"
                        :key="item.visitID"
                        :class="getRowClass(item)"
                    >
                      <td>
                        <span class="queue-badge">{{ item.queueNumber }}</span>
                      </td>
                      <td>
                        <div class="d-flex align-items-center">
                          <div class="avatar-sm me-2">
                                <span class="avatar-title rounded-circle" :class="item.gender === 'Male' ? 'bg-primary' : 'bg-pink'">
                                  {{ getInitials(item.patientName) }}
                                </span>
                          </div>
                          <div>
                            <h6 class="mb-0">{{ item.patientName }}</h6>
                            <small class="text-muted">{{ item.patientID }} &bull; {{ item.gender }} &bull; {{ item.age }} yrs</small>
                          </div>
                        </div>
                      </td>
                      <td>
                        <span class="badge" :class="getVisitTypeBadge(item.visitType)">{{ item.visitType }}</span>
                      </td>
                      <td>{{ item.paymentMode }}</td>
                      <td>
                            <span class="badge" :class="getStatusBadge(item.queueStatus)">
                              {{ formatStatus(item.queueStatus) }}
                            </span>
                        <!-- Doctor assignment indicator -->
                        <div v-if="item.queueStatus === 'In Consultation'" class="mt-1">
                          <small v-if="item.assignedDoctorName" class="text-success">
                            <i class="mdi mdi-doctor me-1"></i>Dr. {{ item.assignedDoctorName }}
                          </small>
                          <small v-else class="text-danger">
                            <i class="mdi mdi-alert-circle me-1"></i>No doctor assigned
                          </small>
                        </div>
                      </td>
                      <td>
                            <span :class="{ 'text-danger fw-bold': getWaitMinutes(item.dateCreated) > 30 }">
                              {{ formatWaitTime(item.dateCreated) }}
                            </span>
                      </td>
                      <td>
                            <span class="text-truncate d-inline-block" style="max-width: 150px;" :title="item.chiefComplaint">
                              {{ item.chiefComplaint || '-' }}
                            </span>
                      </td>
                      <td>
                        <div class="d-flex gap-1">
                          <button class="btn btn-sm btn-soft-primary" @click="viewPatient(item)" title="View Patient">
                            <i class="mdi mdi-eye"></i>
                          </button>
                          <button
                              v-if="item.queueStatus === 'Waiting' || item.queueStatus === 'In Triage'"
                              class="btn btn-sm btn-soft-warning"
                              @click="startTriage(item)"
                              title="Start Triage"
                          >
                            <i class="mdi mdi-pulse"></i>
                          </button>
                          <!-- Consultation button - only if doctor assigned -->
                          <button
                              v-if="item.queueStatus === 'In Consultation' && item.assignedDoctorID"
                              class="btn btn-sm btn-soft-success"
                              @click="startConsultation(item)"
                              title="Start Consultation"
                          >
                            <i class="mdi mdi-stethoscope"></i>
                          </button>
                          <!-- Assign Doctor button - if in consultation but no doctor -->
                          <button
                              v-if="item.queueStatus === 'In Consultation' && !item.assignedDoctorID"
                              class="btn btn-sm btn-soft-danger"
                              @click="showAssignDoctor(item)"
                              title="Assign Doctor First"
                          >
                            <i class="mdi mdi-doctor"></i>
                          </button>
                          <div class="dropdown">
                            <button class="btn btn-sm btn-soft-secondary dropdown-toggle" data-bs-toggle="dropdown">
                              <i class="mdi mdi-dots-vertical"></i>
                            </button>
                            <ul class="dropdown-menu dropdown-menu-end">
                              <li><a class="dropdown-item" href="javascript:void(0);" @click="viewVisitDetails(item)"><i class="mdi mdi-clipboard-text me-2"></i>Visit Details</a></li>
                              <li><a class="dropdown-item" href="javascript:void(0);" @click="showAssignDoctor(item)"><i class="mdi mdi-doctor me-2"></i>Assign Doctor</a></li>
                              <li><hr class="dropdown-divider"></li>
                              <li><a class="dropdown-item text-danger" href="javascript:void(0);" @click="cancelVisit(item)"><i class="mdi mdi-close-circle me-2"></i>Cancel Visit</a></li>
                            </ul>
                          </div>
                        </div>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>

                <!-- Auto-refresh indicator -->
                <div class="text-center text-muted small mt-3" v-if="!loading && filteredQueue.length > 0">
                  <i class="mdi mdi-refresh me-1"></i> Auto-refreshes every 30 seconds
                </div>
              </div>
            </div>

          </div>
        </div>

        <footer class="footer">
          <div class="container-fluid">
            <div class="row">
              <div class="col-sm-6"></div>
              <div class="col-sm-6">
                <div class="text-sm-end d-sm-block">County Hospital Management System</div>
              </div>
            </div>
          </div>
        </footer>
      </div>
    </div>

    <!-- Assign Doctor Modal -->
    <div class="modal fade" id="assignDoctorModal" tabindex="-1">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title"><i class="mdi mdi-doctor me-2"></i>Assign Doctor</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
          </div>
          <div class="modal-body">
            <div class="mb-3">
              <label class="form-label">Patient</label>
              <input type="text" class="form-control" :value="selectedVisit?.patientName" disabled>
            </div>
            <div class="mb-3">
              <label class="form-label">Select Doctor <span class="text-danger">*</span></label>
              <select class="form-select" v-model="selectedDoctor">
                <option value="">Choose a doctor...</option>
                <option v-for="doc in doctors" :key="doc.staffID" :value="doc.staffID">
                  Dr. {{ doc.fullNames }} - {{ doc.specialization || doc.departmentName }}
                </option>
              </select>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-light" data-bs-dismiss="modal">Cancel</button>
            <button type="button" class="btn btn-primary" @click="assignDoctor" :disabled="!selectedDoctor || assigning">
              <span v-if="assigning"><i class="mdi mdi-loading mdi-spin me-1"></i> Assigning...</span>
              <span v-else><i class="mdi mdi-check me-1"></i> Assign</span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- Toast Notification -->
    <ToastNotification ref="toast" />
    </body>
  </div>
</template>

<script>
/* eslint-disable */
import NavigationBar from "@/components/Navigation.vue";
import ToastNotification from "@/components/hospital/ToastNotification.vue";
import { execute, hospital } from "@/api";

export default {
  name: "QueueManagement",
  components: { NavigationBar, ToastNotification },
  data() {
    return {
      loading: false,
      queueData: [],
      stats: {},
      activeTab: 'ALL',

      // Doctors
      doctors: [],
      selectedVisit: null,
      selectedDoctor: '',
      assigning: false,

      // Auto refresh
      refreshInterval: null,

      // Session
      facilityID: '',
      sessionNames: '',
      sessionIdNo: ''
    };
  },
  computed: {
    filteredQueue() {
      if (this.activeTab === 'ALL') return this.queueData;

      const statusMap = {
        'TRIAGE': ['Waiting', 'In Triage'],
        'CONSULTATION': ['In Consultation'],
        'LAB': ['In Lab'],
        'PHARMACY': ['In Pharmacy']
      };

      const statuses = statusMap[this.activeTab] || [];
      return this.queueData.filter(item => statuses.includes(item.queueStatus));
    }
  },
  methods: {
    goTo(route) {
      this.$router.push('/' + route);
    },

    setTab(tab) {
      this.activeTab = tab;
    },

    getInitials(name) {
      if (!name) return '?';
      return name.split(' ').map(n => n[0]).join('').substring(0, 2).toUpperCase();
    },

    filterByStatus(statuses) {
      return this.queueData.filter(item => statuses.includes(item.queueStatus));
    },

    getVisitTypeBadge(type) {
      if (!type) return 'bg-secondary';
      const typeLower = type.toLowerCase();
      if (typeLower === 'opd') return 'bg-primary';
      if (typeLower === 'emergency') return 'bg-danger';
      if (typeLower === 'referral') return 'bg-info';
      if (typeLower === 'follow_up' || typeLower === 'follow-up' || typeLower === 'follow up') return 'bg-secondary';
      if (typeLower === 'mch') return 'bg-pink';
      if (typeLower === 'dental') return 'bg-warning';
      if (typeLower === 'specialist') return 'bg-purple';
      return 'bg-secondary';
    },

    getStatusBadge(status) {
      const badges = {
        'Waiting': 'bg-warning text-dark',
        'In Triage': 'bg-warning',
        'In Consultation': 'bg-primary',
        'In Lab': 'bg-info',
        'In Pharmacy': 'bg-success',
        'Completed': 'bg-success',
        'Cancelled': 'bg-danger'
      };
      return badges[status] || 'bg-secondary';
    },

    formatStatus(status) {
      return status || '-';
    },

    getWaitMinutes(dateCreated) {
      if (!dateCreated) return 0;
      const created = new Date(dateCreated);
      const now = new Date();
      return Math.floor((now - created) / 60000);
    },

    formatWaitTime(dateCreated) {
      const mins = this.getWaitMinutes(dateCreated);
      if (mins < 60) return `${mins} min`;
      const hours = Math.floor(mins / 60);
      const remaining = mins % 60;
      return `${hours}h ${remaining}m`;
    },

    getRowClass(item) {
      const mins = this.getWaitMinutes(item.dateCreated);
      if (item.visitType === 'Emergency') return 'table-danger';
      if (mins > 60) return 'table-danger';
      if (mins > 30) return 'table-warning';
      return '';
    },

    loadQueue() {
      this.loading = true;

      const data = new FormData();
      data.append("function", "getQueueManagement");
      data.append("facilityID", this.facilityID);

      execute(data, hospital)
          .then((res) => {
            this.loading = false;
            if (res.data.success) {
              const responseData = res.data.data || {};

              // Handle queue - could be in 'queue', 'Records', or directly as array
              if (responseData.queue) {
                this.queueData = responseData.queue;
              } else if (responseData.Records && Array.isArray(responseData.Records)) {
                // Check if Records contains queue data (has visitID) or stats
                if (responseData.Records.length > 0 && responseData.Records[0].visitID) {
                  this.queueData = responseData.Records;
                }
              } else {
                this.queueData = [];
              }

              // Handle stats - could be in 'stats', 'Records[0]', or nested
              if (responseData.stats) {
                // Stats might be an object or array with one object
                this.stats = Array.isArray(responseData.stats) ? responseData.stats[0] : responseData.stats;
              } else if (responseData.Records && responseData.Records.length > 0 && responseData.Records[0].triage !== undefined) {
                // Stats returned as Records array
                this.stats = responseData.Records[0];
              } else {
                this.stats = {};
              }
            }
          })
          .catch((e) => {
            this.loading = false;
            console.error(e);
          });
    },

    loadDoctors() {
      const data = new FormData();
      data.append("function", "getDoctors");
      data.append("facilityID", this.facilityID);

      execute(data, hospital)
          .then((res) => {
            if (res.data.success) {
              this.doctors = res.data.data.doctors || [];
            }
          })
          .catch((e) => console.error(e));
    },

    viewPatient(item) {
      this.$router.push('/patient-profile/' + item.patientID);
    },

    viewVisitDetails(item) {
      this.$router.push('/visit-details/' + item.visitID);
    },

    startTriage(item) {
      this.$router.push('/triage-assessment/' + item.visitID);
    },

    startConsultation(item) {
      // Check if doctor is assigned
      if (!item.assignedDoctorID) {
        this.$refs.toast.error('Please assign a doctor first before starting consultation');
        this.showAssignDoctor(item);
        return;
      }
      this.$router.push('/consultation/' + item.visitID);
    },

    showAssignDoctor(item) {
      this.selectedVisit = item;
      this.selectedDoctor = item.assignedDoctorID || '';
      const modal = new bootstrap.Modal(document.getElementById('assignDoctorModal'));
      modal.show();
    },

    assignDoctor() {
      if (!this.selectedDoctor || !this.selectedVisit) return;

      this.assigning = true;

      // Find selected doctor's name
      const doctor = this.doctors.find(d => d.staffID === this.selectedDoctor);
      const doctorName = doctor ? doctor.fullNames : '';

      const data = new FormData();
      data.append("function", "assignDoctor");
      data.append("visitID", this.selectedVisit.visitID);
      data.append("doctorID", this.selectedDoctor);
      data.append("doctorName", doctorName);
      data.append("sessionNames", this.sessionNames);
      data.append("sessionIdNo", this.sessionIdNo);

      execute(data, hospital)
          .then((res) => {
            this.assigning = false;
            if (res.data.success) {
              this.$refs.toast.success('Doctor assigned successfully');
              bootstrap.Modal.getInstance(document.getElementById('assignDoctorModal')).hide();
              this.loadQueue();
            } else {
              this.$refs.toast.error(res.data.message || 'Failed to assign doctor');
            }
          })
          .catch((e) => {
            this.assigning = false;
            console.error(e);
            this.$refs.toast.error('Error assigning doctor');
          });
    },

    cancelVisit(item) {
      if (!confirm('Are you sure you want to cancel this visit?')) return;

      const data = new FormData();
      data.append("function", "updateVisitStatus");
      data.append("visitID", item.visitID);
      data.append("visitStatus", "CANCELLED");
      data.append("sessionNames", this.sessionNames);
      data.append("sessionIdNo", this.sessionIdNo);

      execute(data, hospital)
          .then((res) => {
            if (res.data.success) {
              this.$refs.toast.success('Visit cancelled');
              this.loadQueue();
            } else {
              this.$refs.toast.error(res.data.message || 'Failed to cancel visit');
            }
          })
          .catch((e) => {
            console.error(e);
            this.$refs.toast.error('Error cancelling visit');
          });
    }
  },
  mounted() {
    this.facilityID = sessionStorage.getItem("hospitalFacilityID") || '';
    this.sessionNames = sessionStorage.getItem("sessionNames") || '';
    this.sessionIdNo = sessionStorage.getItem("sessionIdNo") || '';

    this.loadQueue();
    this.loadDoctors();

    // Auto-refresh every 30 seconds
    this.refreshInterval = setInterval(() => {
      this.loadQueue();
    }, 30000);
  },
  beforeUnmount() {
    if (this.refreshInterval) {
      clearInterval(this.refreshInterval);
    }
  }
};
</script>

<style scoped>
/* Avatar Styles */
.avatar-sm { width: 2.25rem; height: 2.25rem; }
.avatar-title {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  font-weight: 600;
  color: #fff;
  font-size: 0.75rem;
}

/* Colors */
.bg-pink { background-color: #e83e8c !important; }
.bg-purple { background-color: #6f42c1 !important; }

/* Queue Badge */
.queue-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  background: linear-gradient(135deg, #556ee6 0%, #3b5de7 100%);
  color: #fff;
  font-weight: 700;
  font-size: 1.1rem;
  border-radius: 10px;
}

/* Nav Tabs */
.nav-tabs-custom .nav-link {
  color: #495057;
  border: none;
  padding: 0.75rem 1rem;
  font-weight: 500;
}

.nav-tabs-custom .nav-link.active {
  color: #556ee6;
  border-bottom: 2px solid #556ee6;
  background: transparent;
}

.nav-tabs-custom .nav-link:hover:not(.active) {
  color: #556ee6;
}

/* Empty State */
.empty-state-icon {
  width: 80px;
  height: 80px;
  background: #f8f9fa;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
}

.empty-state-icon i {
  font-size: 40px;
  color: #adb5bd;
}

/* Soft Buttons */
.btn-soft-primary { background-color: rgba(85, 110, 230, 0.1); color: #556ee6; border: none; }
.btn-soft-primary:hover { background-color: #556ee6; color: #fff; }

.btn-soft-warning { background-color: rgba(241, 180, 76, 0.1); color: #f1b44c; border: none; }
.btn-soft-warning:hover { background-color: #f1b44c; color: #fff; }

.btn-soft-success { background-color: rgba(52, 195, 143, 0.1); color: #34c38f; border: none; }
.btn-soft-success:hover { background-color: #34c38f; color: #fff; }

.btn-soft-danger { background-color: rgba(244, 106, 106, 0.1); color: #f46a6a; border: none; }
.btn-soft-danger:hover { background-color: #f46a6a; color: #fff; }

.btn-soft-secondary { background-color: rgba(116, 120, 141, 0.1); color: #74788d; border: none; }
.btn-soft-secondary:hover { background-color: #74788d; color: #fff; }

/* Card */
.card {
  border: none;
  box-shadow: 0 2px 12px rgba(0,0,0,0.08);
}

/* Mini Stats */
.mini-stats-wid .mini-stat-icon {
  width: 48px;
  height: 48px;
}

/* Table */
.table > :not(caption) > * > * {
  padding: 0.85rem 0.75rem;
}
</style>